import {ContentInfo} from "./content-info";

export class TrackEditInfo {
  constructor(
    public id: string,
    public audio_content: ContentInfo,
    public image_content: ContentInfo,
    public title: string,
    public description: string,
    public is_paid: boolean,
    public is_bonus: boolean,
    public bonus_questionnaire_attempts: number,
    public playlist_ids: string[]
  ) {
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/track-edit-info.ts